import { Predicate } from '@teammood/filter';
import { Report, ReportWithChartData } from './reporting.type';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { SnackBarService } from '@teammood/shared/ui/snack-bar';

@Injectable({ 
    providedIn: 'root' 
})
export class ReportingService {

    constructor(
        private http: HttpClient, 
        private snackBarService: SnackBarService
    ) {}

    async reporting(filter: Predicate[], interval: {start: string, end: string}): Promise<ReportWithChartData> {
        if(filter){
            const report = await firstValueFrom(this.http.post<Report>(`/api/stats/reporting?start=${interval.start}&end=${interval.end}`, {
                predicates: filter
            }));

            if (report.error && filter.length > 0) {
                this.snackBarService.error(report.error);
            } else {
                return {
                    ...report,
                    moodDistributionData: this.transformMoodDistributionData(report),
                    participationDistributionData: this.transformParticipationDistributionData(report)
                }
            }
        }

    }
  
    private transformMoodDistributionData(report): any {
        if(report.moodDistribution) {
            const moodTotalCount = report.moodDistribution.positive + report.moodDistribution.neutral + report.moodDistribution.negative;
            if(moodTotalCount !== 0) {
                return {
                    "positive": report.moodDistribution.positive,
                    "neutral": report.moodDistribution.neutral,
                    "negative": report.moodDistribution.negative,
                    "positiveProp": (report.moodDistribution.positive / moodTotalCount * 100).toFixed(1),
                    "neutralProp": (report.moodDistribution.neutral / moodTotalCount * 100).toFixed(1),
                    "negativeProp": (report.moodDistribution.negative / moodTotalCount * 100).toFixed(1)
                }
            }else{
                return {
                    "positive": report.moodDistribution.positive,
                    "neutral": report.moodDistribution.neutral,
                    "negative": report.moodDistribution.negative,
                    "positiveProp": 0,
                    "neutralProp": 0,
                    "negativeProp": 0
                }
            }    
        }
    }

    private transformParticipationDistributionData(report): any{
        if(report.participationDistribution) {
            const participationTotalCount = report.participationDistribution.noResponse + report.participationDistribution.occasional + report.participationDistribution.regular;
            if(participationTotalCount !== 0){
                return {
                    "noResponse": report.participationDistribution.noResponse,
                    "occasional": report.participationDistribution.occasional,
                    "regular": report.participationDistribution.regular,
                    "noResponseProp": (report.participationDistribution.noResponse/participationTotalCount*100).toFixed(1),
                    "occasionalProp": (report.participationDistribution.occasional/participationTotalCount*100).toFixed(1),
                    "regularProp": (report.participationDistribution.regular/participationTotalCount*100).toFixed(1)
                }
            }else{
                return {
                    "noResponse": report.participationDistribution.noResponse,
                    "occasional": report.participationDistribution.occasional,
                    "regular": report.participationDistribution.regular,
                    "noResponseProp": 0,
                    "occasionalProp": 0,
                    "regularProp": 0
                }
            }
        }
    
    }
}